var _style, _g, _path, _g2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-filter_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-filter_svg__st0{opacity:.5}.icon-filter_svg__st1{fill:#050505}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-filter_svg__st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-filter_svg__st1",
    d: "M20.8 17.2h-9.1c-.6 0-1-.4-1-1s.4-1 1-1h9.1c.6 0 1 .4 1 1s-.4 1-1 1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-filter_svg__st1",
    d: "M5.6 19.6c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.5 3.5-3.5 3.5zm0-4.9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.6-1.5-1.5-1.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "icon-filter_svg__st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-filter_svg__st1",
    d: "M12.3 8.8H3.2c-.6 0-1-.4-1-1s.4-1 1-1h9.1c.6 0 1 .4 1 1s-.5 1-1 1z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-filter_svg__st1",
    d: "M18.4 11.3c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5c-.1 2-1.6 3.5-3.5 3.5zm0-4.9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5z"
  })));
}

export default SvgIconFilter;